<ng-template #closeButton>
  <button type="button" class="ml-2 mb-1 close" aria-label="Close" (click)="onDismiss($event)">
    <span aria-hidden="true">&times;</span>
  </button>
</ng-template>

<div *ngIf="visible" [ngClass]="style" role="alert" aria-live="assertive" aria-atomic="true">
  <div *ngIf="header" class="toast-header">
    <strong class="mr-auto">{{ header }}</strong>
    <ng-container *ngTemplateOutlet="closeButton"></ng-container>
  </div>
  <div class="toast-body row">
    <div class="col">
      <slot>{{ message }}</slot>
    </div>
    <div *ngIf="!header" class="col-1">
      <ng-container *ngTemplateOutlet="closeButton"></ng-container>
    </div>
  </div>
</div>
